<template>
  <div class="csb-page">
    <div class="csb-card">
      <h1 class="csb-title">购买卡密</h1>

      <div class="csb-field">
        <label class="csb-label">选择购买选项</label>
        <div class="csb-select-wrap">
          <select v-model="planOption" class="csb-select">
            <option v-for="opt in planOptions" :key="opt.value" :value="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="csb-field">
        <label class="csb-label">联系方式</label>
        <input
          v-model="contact"
          class="csb-input"
          type="text"
          placeholder="请输入您的TG号"
        />
      </div>

      <button type="button" class="csb-pay" :disabled="loading" @click="onPay">
        {{ loading ? '提交中...' : '点击付款' }}
      </button>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { message } from 'ant-design-vue';
import { addOrder } from '../util/api';
import { resolveReferralContext } from '../util/deeplink';
import { makeOrderNo, pushSelectWallet } from '../util/paymentFlow';

const PLAN_PRICE = {
  '5min': 0.1,
  '30min': 0.5,
  '1h': 1,
  '24h': 5,
};

export default {
  name: 'CardSecretBuy',
  setup() {
    const route = useRoute();
    const router = useRouter();
    const contact = ref('');
    const planOption = ref('5min');
    const loading = ref(false);
    const referral_code = ref('');
    const gameGroupId = ref('');

    const planOptions = [
      { value: '5min', label: '5分钟试用(0.1u)' },
      { value: '30min', label: '30分钟(0.5u)' },
      { value: '1h', label: '1小时(1u)' },
      { value: '24h', label: '24小时(5u)' },
    ];

    onMounted(() => {
      const ctx = resolveReferralContext(route);
      referral_code.value = ctx.referralCode;
      gameGroupId.value = ctx.gameGroupId;
    });

    const onPay = async () => {
      if (!contact.value.trim()) {
        message.warning('请输入您的TG号');
        return;
      }
      const plan = planOptions.find((p) => p.value === planOption.value);
      const price = PLAN_PRICE[planOption.value] ?? 0.1;
      const data = {
        price,
        inputNumber: 1,
        inputGT: contact.value.trim(),
        orderNo: makeOrderNo(),
        title: `购买卡密-${plan?.label || planOption.value}`,
        referral_code: referral_code.value,
      };

      loading.value = true;
      try {
        await addOrder(data);
        pushSelectWallet(router, data, gameGroupId.value);
      } catch (e) {
        console.error(e);
        message.error('下单失败，请稍后重试');
      } finally {
        loading.value = false;
      }
    };

    return {
      contact,
      planOption,
      planOptions,
      loading,
      onPay,
    };
  },
};
</script>

<style scoped>
.csb-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: #f7f7f7;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: max(24px, env(safe-area-inset-top)) 16px max(24px, env(safe-area-inset-bottom));
  box-sizing: border-box;
}

.csb-card {
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  padding: 32px 28px 36px;
  box-sizing: border-box;
}

.csb-title {
  margin: 0 0 28px;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  color: #333333;
}

.csb-field {
  margin-bottom: 20px;
}

.csb-label {
  display: block;
  margin-bottom: 10px;
  font-size: 13px;
  color: #666666;
}

.csb-input,
.csb-select {
  width: 100%;
  height: 44px;
  padding: 0 14px;
  font-size: 16px;
  color: #333333;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  box-sizing: border-box;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
}

.csb-input {
  background: #f5f7fa;
}

.csb-input::placeholder {
  color: #c0c4cc;
}

.csb-input:focus,
.csb-select:focus {
  border-color: #61a5e9;
  background: #ffffff;
}

.csb-select-wrap {
  position: relative;
}

.csb-select-wrap::after {
  content: '';
  position: absolute;
  right: 14px;
  top: 50%;
  width: 0;
  height: 0;
  margin-top: -2px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #909399;
  pointer-events: none;
}

.csb-select {
  background: #ffffff;
  padding-right: 36px;
  cursor: pointer;
}

.csb-pay {
  width: 100%;
  height: 46px;
  margin-top: 8px;
  border: none;
  border-radius: 8px;
  background: #61a5e9;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.csb-pay:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.csb-pay:active:not(:disabled) {
  background: #4f95d9;
}

@media (max-width: 480px) {
  .csb-page {
    padding-top: 20px;
    align-items: stretch;
  }

  .csb-card {
    max-width: none;
    border-radius: 10px;
    padding: 24px 16px 28px;
    box-shadow: none;
    border: 1px solid #eee;
  }
}
</style>
